<template>
    <footer class="footer">
        <div class="footer-top">
            <div class="container">
                <div class="footer-link-wrap">

                    <ul class="footer-link">
                        <li><a href="/company">회사소개</a></li>
                        <li><a href="/policy">이용약관</a></li>
                        <li><a href="/privacy">개인정보 취급방침</a></li>
                        <li><a href="/company#green">친환경벽지</a></li>
                    </ul>
                </div>
                <ul class="footer-right">
                    <li><a href="/">design id DID</a></li>
                </ul>
            </div>
        </div>
        <div class="footer-bottom">
            <div class="container">
                <div class="footer-col">
                    <ul class="footer-info">
                        <li>서울특별시 강남구 봉은사로 327(논현동) 궁도빌딩 10-13층</li>
                        <li>대표번호 02-2141-3930</li>
                        <li>이메일 customer@didwallpaper.com</li>
                        <li>사업자등록번호 220-85-09219</li>
                        <!-- <li>정보책임자 이돈영</li> -->
                        <li>Copyright (c) 2020 didwallpaper all right reserved.</li>
                    </ul>
                </div>
            </div>
        </div>
    </footer>
</template>

<script>

export default {
    components: {
    }
}
</script>
